import React from 'react';

import Create from '@material-ui/icons/Create';
import Warning from '@material-ui/icons/PriorityHigh';
import Search from '@material-ui/icons/Search';

import { IAdornmentProps } from './EndAdornment';

export const Icon = ({ type, error }: IAdornmentProps) => {
  const IconComponent = error ? Warning : type === 'search' ? Search : Create;

  return <IconComponent color="primary" classes={{ root: 'input-icon override' }} />;
};
